var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescargar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.2007 6H4.80065C2.66732 6 1.33398 7.33333 1.33398 9.46667V11.1933C1.33398 13.3333 2.66732 14.6667 4.80065 14.6667H11.194C13.3273 14.6667 14.6607 13.3333 14.6607 11.2V9.46667C14.6673 7.33333 13.334 6 11.2007 6Z",
    fill: "#0A0A0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5859 8.28683L8.35258 10.5202C8.15925 10.7135 7.83925 10.7135 7.64591 10.5202L5.41258 8.28683C5.21924 8.0935 5.21924 7.7735 5.41258 7.58016C5.60591 7.38683 5.92591 7.38683 6.11925 7.58016L7.49924 8.96016V1.8335C7.49924 1.56016 7.72591 1.3335 7.99925 1.3335C8.27258 1.3335 8.49925 1.56016 8.49925 1.8335V8.96016L9.87924 7.58016C9.97925 7.48016 10.1059 7.4335 10.2326 7.4335C10.3592 7.4335 10.4859 7.48016 10.5859 7.58016C10.7859 7.7735 10.7859 8.08683 10.5859 8.28683Z",
    fill: "#0A0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescargar);
export default __webpack_public_path__ + "static/media/Descargar.a46322ec92d29049164515c2d45b8c92.svg";
export { ForwardRef as ReactComponent };